<template>
  <div class="flex items-center flex-wrap h-full" style="gap: 4px;">
    <span v-if="!hasDates">-</span>
    <template v-else>
      <span>{{ visibleDatesText }}</span>
      <button
        v-if="hasMore"
        type="button"
        class="text-primary underline"
        style="margin-right: 6px;"
        @click="showMore"
      >
        عرض المزيد
      </button>
    </template>
  </div>
</template>

<script>
import utilities from "@/app/shared/utilities/index";
import Vue from "vue";

const VISIBLE_DATES_COUNT = 1;

export default Vue.extend({
  name: "AvailabilityDatesCell",
  computed: {
    dates() {
      return Array.isArray(this.params.data.dates) ? this.params.data.dates : [];
    },
    hasDates() {
      return this.dates.length > 0;
    },
    hasMore() {
      return this.dates.length > VISIBLE_DATES_COUNT;
    },
    visibleDatesText() {
      return this.dates
        .slice(0, VISIBLE_DATES_COUNT)
        .map((date) => `${utilities.formatDayName(date)} - ${date}`.trim())
        .join('، ');
    },
  },
  methods: {
    showMore() {
      this.params.onShowMore(this.params.data);
    },
  },
});
</script>
